<template>
  <b-modal
    ref="bill-history-modal"
    v-model="showModal"
    size="xl"
    :title="`Chi tiết lịch sử hóa đơn - ${id || ''}`"
    header-bg-variant="light"
    @hidden="onModalHidden"
    @show="onModalShow"
    no-close-on-backdrop
    scrollable
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div v-if="!isLoading && historyData">
        <h5 class="bold-text">Thông tin log</h5>
        <hr />
        <b-container class="bv-example-row">
          <b-row class="justify-content-md-center mb-10">
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Loại log:</p>
                  <p class="header-color">Mã:</p>
                </b-col>
                <b-col>
                  <p>{{ historyData.type }}</p>
                  <p>{{ historyData.id }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Người sửa:</p>
                  <p class="header-color">IP:</p>
                </b-col>
                <b-col>
                  <p>
                    <b>{{ historyData.updatedBy }}</b>
                  </p>
                  <p>{{ historyData.clientIp }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-4">
                  <p class="header-color">Thiết bị:</p>
                </b-col>
                <b-col>
                  <p>
                    <span class="text-muted">
                      OS: {{ historyData.userAgent.osName }}
                    </span>
                  </p>
                  <span class="text-muted">
                    Browser:
                    {{ historyData.userAgent.browserName }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <h5 class="bold-text">Thông tin thay đổi</h5>
        <hr />
        <b-container class="bv-example-row">
          <table
            border="1"
            style="width: 60%"
            class="table table-bordered table-vertical-center table-hover mb-10"
          >
            <colgroup>
              <col style="width: 20%" />
              <col style="width: 40%" />
              <col style="width: 40%" />
            </colgroup>
            <thead class="bg-secondary">
              <tr>
                <th rowspan="2">Thông tin</th>
              </tr>
              <tr>
                <th>Trước khi sửa</th>
                <th>Sau khi sửa</th>
              </tr>
            </thead>
            <tbody v-if="hasDiffInfo">
              <tr
                v-if="
                  historyData.diffInfo._.customerNote &&
                  isModified(historyData.diffInfo._.customerNote)
                "
              >
                <th class="header-color">Ghi chú khách hàng</th>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.original
                      : ''
                  }}
                </td>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.current
                      : ''
                  }}
                </td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.customerNote)">
                <th class="header-color">Ghi chú khách hàng</th>
                <td></td>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.current
                      : ''
                  }}
                </td>
              </tr>

              <tr
                v-if="isModified(historyData.diffInfo._.discountAmount?.status)"
              >
                <th class="header-color">Chiết khấu</th>
                <td>{{ historyData.diffInfo._.discountAmount?.original }}</td>
                <td>{{ historyData.diffInfo._.discountAmount?.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.discountAmount?.status)">
                <th class="header-color">Chiết khấu</th>
                <td></td>
                <td>{{ historyData.diffInfo._.discountAmount?.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.discountType?.status)"
              >
                <th class="header-color">Kiểu chiết khấu</th>
                <td>{{ historyData.diffInfo._.discountType?.original }}</td>
                <td>{{ historyData.diffInfo._.discountType?.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.discountType?.status)">
                <th class="header-color">Kiểu chiết khấu</th>
                <td></td>
                <td>{{ historyData.diffInfo._.discountType?.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.orderSourceId.status)"
              >
                <th class="header-color">Nguồn đơn hàng</th>
                <td>{{ historyData.diffInfo._.orderSourceId.original }}</td>
                <td>{{ historyData.diffInfo._.orderSourceId.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.orderSourceId.status)">
                <th class="header-color">Nguồn đơn hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.orderSourceId.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.saleNote.status)">
                <th class="header-color">Ghi chú CSKH</th>
                <td>{{ historyData.diffInfo._.saleNote.original }}</td>
                <td>{{ historyData.diffInfo._.saleNote.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.saleNote.status)">
                <th class="header-color">Ghi chú CSKH</th>
                <td></td>
                <td>{{ historyData.diffInfo._.saleNote.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.customerNote.status)">
                <th class="header-color">Ghi chú khách hàng</th>
                <td>{{ historyData.diffInfo._.customerNote.original }}</td>
                <td>{{ historyData.diffInfo._.customerNote.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.customerNote.status)">
                <th class="header-color">Ghi chú khách hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.customerNote.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.warrantyNote.status)">
                <th class="header-color">Ghi chú bảo hành</th>
                <td>{{ historyData.diffInfo._.warrantyNote.original }}</td>
                <td>{{ historyData.diffInfo._.warrantyNote.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.warrantyNote.status)">
                <th class="header-color">Ghi chú bảo hành</th>
                <td></td>
                <td>{{ historyData.diffInfo._.warrantyNote.current }}</td>
              </tr>
            </tbody>
          </table>
        </b-container>

        <div v-if="historyData.action !== 4">
          <h5 class="bold-text">Chi tiết thay đổi sản phẩm</h5>
          <hr />
          <b-container class="bv-example-row">
            <table
              class="table table-bordered table-vertical-center table-hover mb-10"
            >
              <thead class="bg-secondary">
                <tr>
                  <th style="width: 50%">Trước khi sửa</th>
                  <th style="width: 50%">Sau khi sửa</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in hasDiffItem
                    ? historyData.diffItem._
                    : []"
                  :key="index"
                >
                  <td>
                    <div
                      v-if="item.status === 'ADDED'"
                      v-show="item.status === 'ADDED'"
                    >
                      <span>{{ item.original }}</span>
                    </div>

                    <div>
                      <span
                        v-if="item.status === 'MODIFIED'"
                        v-show="item.status === 'MODIFIED'"
                      >
                        <p class="text-primary header-color">
                          {{ item._.productName.original }}
                        </p>
                        <b-row>
                          <b-col class="col col-sm-3">
                            <p class="header-color">ID sản phẩm:</p>
                            <p class="header-color">IMEI:</p>
                            <p class="header-color">Giá:</p>
                            <p class="header-color">Số lượng:</p>
                            <p class="header-color">Chiết khấu:</p>
                          </b-col>
                          <b-col>
                            <p>{{ item._.productId.original || 0 }}</p>
                            <p>
                              {{
                                item._.imeiCode.original !== ''
                                  ? item._.imeiCode.current
                                  : 0
                              }}
                            </p>
                            <p>
                              {{ convertPrice(item._.productPrice.original) }}
                            </p>
                            <p>{{ item._.quantity.original }}</p>
                            <p>
                              {{ item._.discountAmount.original }}
                              {{
                                getDiscountTypeText(
                                  item._.discountType.original,
                                )
                              }}
                            </p>
                          </b-col>
                        </b-row>
                      </span>
                    </div>
                  </td>

                  <td>
                    <div
                      v-if="item.status === 'ADDED'"
                      v-show="item.status === 'ADDED'"
                    >
                      <p class="text-primary header-color">
                        {{ item.current.productName }}
                      </p>
                      <b-row>
                        <b-col class="col col-sm-3">
                          <p class="header-color">ID sản phẩm:</p>
                          <p class="header-color">IMEI:</p>
                          <p class="header-color">Giá:</p>
                          <p class="header-color">Số lượng:</p>
                          <p class="header-color">Chiết khấu:</p>
                        </b-col>
                        <b-col>
                          <p>{{ item.current.productId }}</p>
                          <p>
                            {{
                              item.current.imeiCode !== ''
                                ? item.current.imeiCode
                                : 0
                            }}
                          </p>
                          <p>{{ convertPrice(item.current.productPrice) }}</p>
                          <p>{{ item.current.quantity }}</p>
                          <p>
                            {{ item.current.discountAmount }}
                            {{ getDiscountTypeText(item.current.discountType) }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                    <div>
                      <span
                        v-if="item.status === 'MODIFIED'"
                        v-show="item.status === 'MODIFIED'"
                      >
                        <p class="text-primary header-color">
                          {{ item._.productName.current }}
                        </p>
                        <b-row>
                          <b-col class="col col-sm-3">
                            <p class="header-color">ID sản phẩm:</p>
                            <p class="header-color">IMEI:</p>
                            <p class="header-color">Giá:</p>
                            <p class="header-color">Số lượng:</p>
                            <p class="header-color">Chiết khấu:</p>
                          </b-col>
                          <b-col>
                            <p>{{ item._.productId.current }}</p>
                            <p>{{ item._.imeiCode.current || 0 }}</p>
                            <p>
                              {{ convertPrice(item._.productPrice.current) }}
                            </p>
                            <p>{{ item._.quantity.current }}</p>
                            <p>
                              {{ item._.discountAmount.current }}
                              {{
                                getDiscountTypeText(item._.discountType.current)
                              }}
                            </p>
                          </b-col>
                        </b-row>
                      </span>
                    </div>
                    <div v-if="item.status === 'DELETED'">
                      <p class="text-danger header-color">
                        {{ item.original.productName }}
                      </p>
                      <b-row>
                        <b-col class="col col-sm-3">
                          <p class="header-color">ID sản phẩm:</p>
                          <p class="header-color">IMEI:</p>
                          <p class="header-color">Giá:</p>
                          <p class="header-color">Số lượng:</p>
                          <p class="header-color">Chiết khấu:</p>
                        </b-col>
                        <b-col>
                          <p>{{ item.original.productId || 0 }}</p>
                          <p>
                            {{
                              item.original.imeiCode !== ''
                                ? item.original.imeiCode
                                : 0
                            }}
                          </p>
                          <p>
                            {{ convertPrice(item.original.productPrice) }}
                          </p>
                          <p>{{ item.original.quantity }}</p>
                          <p>
                            {{ item.original.discountAmount }}
                            {{
                              getDiscountTypeText(item.original.discountType)
                            }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-container>

          <h5 class="bold-text">Chi tiết thay đổi thanh toán</h5>
          <hr />
          <b-container class="bv-example-row">
            <table
              class="table table-bordered table-vertical-center table-hover mb-10"
            >
              <thead class="bg-secondary">
                <tr>
                  <th style="width: 50%">Trước khi sửa</th>
                  <th style="width: 50%">Sau khi sửa</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in hasDiffPayments
                    ? historyData.diffPayments._
                    : []"
                  :key="index"
                >
                  <td>
                    <div v-if="item._?.paymentName">
                      <strong>Tên:</strong>
                      {{ item._.paymentName.original || '' }}<br />
                      <strong>Số tiền:</strong>
                      {{ convertPrice(item._.paymentAmount?.original) || ''
                      }}<br />
                      <strong>Mã:</strong>
                      {{ item._.paymentCode?.original || '' }}<br />
                      <strong>Loại:</strong>
                      {{ getPaymentTypeText(item._.paymentType?.original) || ''
                      }}<br />
                      <strong>Mã tham chiếu:</strong>
                      {{ item._.paymentRefCode?.original || '' }}<br />
                      <strong>ID tham chiếu:</strong>
                      {{ item._.paymentRefId?.original || '' }}<br />
                      <strong>ID thực thể:</strong>
                      {{ item._.entityRefId?.original || '' }}<br />
                      <strong>Loại thực thể:</strong>
                      {{
                        getEntityRefTypeText(item._.entityRefType?.original) ||
                        ''
                      }}<br />
                      <strong>Thẻ tín dụng:</strong>
                      {{ item._.creditCardNo?.original || '' }}<br />
                      <strong>Mã định danh:</strong>
                      {{ item._.identifyCode?.original || '' }}<br />
                      <strong>Tài khoản NH:</strong>
                      {{ item._.accountBankNo?.original || '' }}<br />
                      <strong>ID giao dịch:</strong>
                      {{ item._.transactionId?.original || '' }}<br />
                      <strong>Số ĐDKH:</strong>
                      {{ item._.customerIndentifyNo?.original || '' }}<br />
                      <strong>Đã xóa:</strong>
                      {{ item._.deleted?.original ? 'Có' : 'Không' }}<br />
                      <strong>Ngày tạo:</strong>
                      {{ formatDateTime(item._.createdAt?.original) || ''
                      }}<br />
                      <strong>Ngày cập nhật:</strong>
                      {{ formatDateTime(item._.updatedAt?.original) || '' }}
                    </div>
                  </td>
                  <td>
                    <div v-if="item._?.paymentName">
                      <strong>Tên:</strong> {{ item._.paymentName.current || ''
                      }}<br />
                      <strong>Số tiền:</strong>
                      {{ convertPrice(item._.paymentAmount?.current) || ''
                      }}<br />
                      <strong>Mã:</strong> {{ item._.paymentCode?.current || ''
                      }}<br />
                      <strong>Loại:</strong>
                      {{ getPaymentTypeText(item._.paymentType?.current) || ''
                      }}<br />
                      <strong>Mã tham chiếu:</strong>
                      {{ item._.paymentRefCode?.current || '' }}<br />
                      <strong>ID tham chiếu:</strong>
                      {{ item._.paymentRefId?.current || '' }}<br />
                      <strong>ID thực thể:</strong>
                      {{ item._.entityRefId?.current || '' }}<br />
                      <strong>Loại thực thể:</strong>
                      {{
                        getEntityRefTypeText(item._.entityRefType?.current) ||
                        ''
                      }}<br />
                      <strong>Thẻ tín dụng:</strong>
                      {{ item._.creditCardNo?.current || '' }}<br />
                      <strong>Mã định danh:</strong>
                      {{ item._.identifyCode?.current || '' }}<br />
                      <strong>Tài khoản NH:</strong>
                      {{ item._.accountBankNo?.current || '' }}<br />
                      <strong>ID giao dịch:</strong>
                      {{ item._.transactionId?.current || '' }}<br />
                      <strong>Số ĐDKH:</strong>
                      {{ item._.customerIndentifyNo?.current || '' }}<br />
                      <strong>Đã xóa:</strong>
                      {{ item._.deleted?.current ? 'Có' : 'Không' }}<br />
                      <strong>Ngày tạo:</strong>
                      {{ formatDateTime(item._.createdAt?.current) || ''
                      }}<br />
                      <strong>Ngày cập nhật:</strong>
                      {{ formatDateTime(item._.updatedAt?.current) || '' }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-container>
        </div>
      </div>
    </b-overlay>
    <template #modal-footer="{ close }">
      <b-button variant="secondary" size="sm" @click="close()"> Đóng </b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { convertPrice } from '@/utils/common';

export default {
  name: 'BillHistoryModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    historyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      historyData: null,
      id: '',
    };
  },
  computed: {
    hasDiffInfo() {
      return (
        this.historyData &&
        this.historyData.diffInfo &&
        this.historyData.diffInfo._
      );
    },
    hasDiffItem() {
      return (
        this.historyData &&
        this.historyData.diffItem &&
        this.historyData.diffItem._
      );
    },
    hasDiffPayments() {
      return (
        this.historyData &&
        this.historyData.diffPayments &&
        this.historyData.diffPayments._
      );
    },
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
      if (newVal && this.historyId) {
        this.loadHistoryData();
      }
    },
    showModal(newVal) {
      this.$emit('update:show', newVal);
      if (newVal) {
        this.updateUrlWithModal();
      } else {
        this.removeUrlModal();
      }
    },
  },
  mounted() {
    this.handleModalFromUrl();

    window.addEventListener('popstate', this.handlePopState);

    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
    document.removeEventListener('keydown', this.handleEscKey);
  },
  methods: {
    convertPrice,
    getHistoryType(typeId) {
      switch (typeId) {
        case 1:
          return 'Đơn hàng';
        case 2:
          return 'Hóa đơn';
        default:
          return '';
      }
    },
    getDiscountTypeText(typeId) {
      switch (typeId) {
        case 1:
          return '($)';
        case 2:
          return '(%)';
        default:
          return '';
      }
    },
    getPaymentTypeText(typeId) {
      switch (typeId) {
        case 1:
          return 'Tiền mặt';
        case 2:
          return 'Chuyển khoản';
        case 3:
          return 'Thẻ tín dụng';
        case 4:
          return 'Thẻ ATM';
        default:
          return typeId || '';
      }
    },
    getEntityRefTypeText(typeId) {
      switch (typeId) {
        case 1:
          return 'Hóa đơn';
        case 2:
          return 'Đơn hàng';
        default:
          return typeId || '';
      }
    },
    getPaymentStatusText(status) {
      switch (status) {
        case 1:
          return 'Chờ xử lý';
        case 2:
          return 'Đã xử lý';
        case 3:
          return 'Thất bại';
        default:
          return status || '';
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      const date = new Date(dateTime);
      return date.toLocaleString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    async loadHistoryData() {
      if (!this.historyId) return;

      this.isLoading = true;
      this.id = this.historyId;

      try {
        const params = { type: 2 };
        const response = await ApiService.query(
          `/v1/histories/${this.historyId}`,
          { params },
        );

        const {
          type,
          action,
          createdByName,
          storeName,
          diffInfo,
          diffItem,
          diffPayments,
          userIP: clientIp,
          userAgent,
        } = response.data.data;

        this.historyData = {
          type: this.getHistoryType(type),
          action,
          id: this.historyId,
          updatedBy: createdByName,
          storeName,
          clientIp,
          diffInfo,
          diffItem,
          diffPayments,
          userAgent,
        };
      } catch (error) {
        console.error('Error loading history data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    isModified(value) {
      return value === 'MODIFIED';
    },

    isAdded(value) {
      return value === 'ADDED';
    },
    onModalShow() {
      this.$emit('show');
    },

    onModalHidden() {
      this.$emit('hidden');
      this.removeUrlModal();
    },

    updateUrlWithModal() {
      if (this.historyId) {
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('modal', 'bill-history');
        currentUrl.searchParams.set('id', this.historyId);
        window.history.pushState(null, '', currentUrl.toString());
      }
    },
    removeUrlModal() {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.delete('modal');
      currentUrl.searchParams.delete('id');
      window.history.replaceState(null, '', currentUrl.toString());
    },

    handleModalFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');
      const historyId = urlParams.get('id');

      if (modal === 'bill-history' && historyId) {
        this.$emit('open-modal', historyId);
      }
    },

    handlePopState() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');

      if (modal !== 'bill-history' && this.showModal) {
        this.showModal = false;
      }
    },

    handleEscKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.showModal = false;
      }
    },
  },
};
</script>
